import ValueSlider from "components/ValueSlider";
import { MarksItem } from "components/ValueSlider/ValueSlider";
import React, { useState } from "react";

interface Props {
  marks: MarksItem[];
  value: number;
  title: string;
  description: string;
  defaultValue: number;
  removeSlider?: boolean;
  descriptions?: string[][];
}

function PriceContainer({
  value,
  marks,
  title,
  description,
  defaultValue,
  removeSlider,
  descriptions,
}: Props) {
  const [slideValue, setSlideValue] = useState(1);

  const [price, setPrice] = useState(defaultValue);

  console.log(value);

  const handleBtnClick = () => {
    window.open("https://bit.ly/Reqdemo", "_blank");
  };

  return (
    <div className="page-padding price_container">
      <div>
        <h4>{title}</h4>
        <h2>
          ${price}
          <span className="text-xs">/mo</span>
        </h2>
        {!removeSlider && (
          <ValueSlider
            setValue={setSlideValue}
            value={value}
            marks={marks}
            setPrice={setPrice}
          />
        )}
      </div>
      <div>
        {descriptions &&
          descriptions[slideValue].map((data, idx) => {
            return (
              <div className="list_items">
                <p className="list_item">• {data}</p>
              </div>
            );
          })}
      </div>
      {/* <p>{description}</p> */}

      {/* <button onClick={handleBtnClick} className="primaryBtn">
        Get it now
      </button> */}
    </div>
  );
}

export default PriceContainer;
